import React, { Component } from 'react';
import { connect } from 'react-redux';

// Components
import List from './List';
import HistoryOverview from './HistoryOverview';

// Thunks
import { getActiveNfForecastHistory } from '../../../../../redux/tracking';

// Selectors
import { getActiveNfForecastHistoryUI } from '../../../../../redux/selectors';

import './styles.css';

class TrackingDetailsHistory extends Component {
  componentDidMount() {
    const { nfData } = this.props;

    this.props.dispatch(getActiveNfForecastHistory({
      nf: nfData.nf,
      nfGroup: nfData.nfGroup ? nfData.nfGroup : null,
      cnpjDest: nfData.cnpjDest,
      cnpjEmit: nfData.cnpjEmit,
      dateNfCreated: nfData.orderDate,
      division: 1,
    }));
  }

    _onRetry = () => {
      const { nfData } = this.props;

      this.props.dispatch(getActiveNfForecastHistory({
        nf: nfData.nf,
        nfGroup: nfData.nfGroup ? nfData.nfGroup : null,
        cnpjDest: nfData.cnpjDest,
        cnpjEmit: nfData.cnpjEmit,
        dateNfCreated: nfData.orderDate,
        division: 1,
      }));
    }

    render() {
      const { nfData, data, ui } = this.props;

      return (
        <div className="TrackingDetailsHistory">
          <div className="TrackingDetailsHistory__overview">
            <HistoryOverview
              isFetching={ui.isFetching}
              orderDate={nfData.orderDate}
              data={data}
              hasError={ui.error}
              onRetry={this._onRetry}
            />
          </div>
          <List
            isFetching={ui.isFetching}
            hasError={ui.error}
            onRetry={this._onRetry}
            data={data}
            className="TrackingDetailsHistory__list"
          />
        </div>
      );
    }
}

function mapStateToProps(state) {
  return {
    data: state.tracking.activeNfForecastHistory.data,
    ui: getActiveNfForecastHistoryUI(state),
  };
}

export default connect(mapStateToProps)(TrackingDetailsHistory);
